import Axios from "axios"

export default {

  /**
   * 全部签约列表
   * @param {*} customer_info 
   * @param {*} realtor_info 
   * @param {*} project_chamber_name 
   * @param {*} user_name 
   * @param {*} first_recognition_datetime_start 
   * @param {*} first_recognition_datetime_end 
   * @param {*} reporting_datetime_start 
   * @param {*} reporting_datetime_end 
   * @param {*} contract_datetime_start 
   * @param {*} contract_datetime_end 
   * @param {*} created_at_start 
   * @param {*} created_at_end
   * @param {*} handle_result_state  
   * @param {*} handle_status 
   * @param {*} pd_net_batch_status
   * @param {*} risk_signing_types 
   * @param {*} page 
   */
  allListPage(
    customer_info,
    realtor_info,
    project_chamber_name,
    user_name,
    first_recognition_datetime_start,
    first_recognition_datetime_end,
    reporting_datetime_start,
    reporting_datetime_end,
    contract_datetime_start,
    contract_datetime_end,
    created_at_start,
    created_at_end,
    handle_result_state,
    handle_status,
    pd_net_batch_status,
    risk_signing_types,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/transactionHistory/list`, {
      params: {
        customer_info,
        realtor_info,
        project_chamber_name,
        user_name,
        first_recognition_datetime_start,
        first_recognition_datetime_end,
        reporting_datetime_start,
        reporting_datetime_end,
        contract_datetime_start,
        contract_datetime_end,
        created_at_start,
        created_at_end,
        handle_result_state,
        handle_status,
        pd_net_batch_status,
        risk_signing_types,
        page
      }
    });
  },
  
  /**
   * 风险签约客户
   * @param {*} customer_info 
   * @param {*} realtor_info 
   * @param {*} project_chamber_name 
   * @param {*} user_name 
   * @param {*} first_recognition_datetime_start 
   * @param {*} first_recognition_datetime_end 
   * @param {*} reporting_datetime_start 
   * @param {*} reporting_datetime_end 
   * @param {*} contract_datetime_start 
   * @param {*} contract_datetime_end 
   * @param {*} created_at_start 
   * @param {*} created_at_end 
   * @param {*} handle_status
   * @param {*} pd_net_batch_status
   * @param {*} risk_signing_types
   * @param {*} page 
   */
  riskListPage(
    customer_info,
    realtor_info,
    project_chamber_name,
    user_name,
    first_recognition_datetime_start,
    first_recognition_datetime_end,
    reporting_datetime_start,
    reporting_datetime_end,
    contract_datetime_start,
    contract_datetime_end,
    created_at_start,
    created_at_end,
    handle_status,
    pd_net_batch_status,
    risk_signing_types,
    page
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/transactionHistory/risk_list`, {
      params: {
        customer_info,
        realtor_info,
        project_chamber_name,
        user_name,
        first_recognition_datetime_start,
        first_recognition_datetime_end,
        reporting_datetime_start,
        reporting_datetime_end,
        contract_datetime_start,
        contract_datetime_end,
        created_at_start,
        created_at_end,
        handle_status,
        pd_net_batch_status,
        risk_signing_types,
        page
      }
    });
  },

  /**
   * 搜索参数
   */
  searchParam() {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/transactionHistory/getParams`);
  },
  
  /**
   * 详情
   * @param {*} customer_transaction_history_id
   */
  info(
    customer_transaction_history_id
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/transactionHistory/detail`, {
      params: {
        customer_transaction_history_id
      }
    });
  },

  /**
   * 搜索相似客户
   * @param {*} contractId 
   * @param {*} similar 
   */
  similarPerson(
    contractId,
    similar
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/contract/${contractId}/projectCustomer/face/search`, {
      params: {
        similar
      }
    })
  },

  /**
   * 风险判定
   * @param {*} customer_transaction_history_id 
   * @param {*} handle_result_state 
   * @param {*} handle_result_reason
   */
  risk(
    customer_transaction_history_id,
    recognition_ids,
    handle_result_state,
    handle_result_reason
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/customer/transactionHistory/handleRiskSign`, {
      customer_transaction_history_id,
      recognition_ids,
      handle_result_state,
      handle_result_reason
    });
  },

  /**
   * 设为风险
   * @param {*} customer_transaction_history_id 
   */
  setRisk(
    customer_transaction_history_id
  ) {
    return Axios.post(`${process.env.VUE_APP_PREFIX}/customer/transactionHistory/manualOperationRiskSign`, {
      customer_transaction_history_id
    });
  },

  /**
   * 网批
   * @param {*} customer_transaction_history_id 
   */
  task(
    customer_transaction_history_id
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/transactionHistory/pdNetBatch`, {
      params: {
        customer_transaction_history_id
      }
    });
  },

  /**
   * 重新分析
   * @param {*} customer_transaction_history_id 
   */
  reanalysis(
    customer_transaction_history_id
  ) {
    return Axios.get(`${process.env.VUE_APP_PREFIX}/customer/transactionHistory/secondTimesAnalysis`, {
      params: {
        customer_transaction_history_id
      }
    });
  }

}